<template>
  <div class="sideToolbarContainer" id="sideToolbarContainer">
    <div class="chat-header" role="heading">
      <template v-if="videoCallRoom.is_sender">{{ $t("videocall.title.tokens_history_sender") }}</template>
      <template v-else>{{ $t("videocall.title.tokens_history") }}</template>
      <div
        aria-label="Cerrar chat"
        class="jitsi-icon jitsi-icon-default"
        role="button"
        tabindex="0"
        @click="$emit('close')"
      >
        <svg
          height="22"
          width="22"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M18.53 6.53a.75.75 0 0 0-1.06-1.06L12 10.94 6.53 5.47a.75.75 0 0 0-1.06 1.06L10.94 12l-5.47 5.47a.75.75 0 1 0 1.06 1.06L12 13.06l5.47 5.47a.75.75 0 1 0 1.06-1.06L13.06 12l5.47-5.47Z"
          ></path>
        </svg>
      </div>
    </div>
    <div
      aria-labelledby="chat-tab"
      class="chat-panel chat-panel-no-tabs"
      id="chat-panel"
      role="tabpanel"
    >
      <div id="chat-conversation-container">
        <div
          aria-labelledby="chat-header"
          id="chatconversation"
          role="log"
          tabindex="0"
        >
          <div class="chat-message-group remote">
            <div
              v-for="log in logsList"
              :key="log.id"
              class="chatmessage-wrapper"
              tabindex="-1"
            >
              <div class="chatmessage">
                <div class="replywrapper">
                  <div class="messagecontent">
                    <div aria-hidden="true" class="display-name">
                      {{ log.emisor }}
                    </div>
                    <div class="usermessage">
                      {{ log.description }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="timestamp" v-if="log.time">{{ log.time }}</div>
              <div class="timestamp-null" v-else></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    videoCallRoom: {
      required: true,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      logsList: [],
    };
  },
  methods: {
    appendLog(log) {
      this.logsList.push(log);
    },
  }
};
</script>

<style scoped lang="scss">
@import "./jisti.scss";

.timestamp-null {
  padding-bottom: 0.5rem;
}

#sideToolbarContainer {
  height: 100%;

  #chat-panel {
    height: 100%;
  }
}
</style>
